import React from 'react';

import { Card, AccordionRow } from '@ergeon/core-components';

import ActivityHeader from './ActivityHeader';
import ActivityContent from './ActivityContent';
import type { Activity } from './types';

type ActivityCardProps = {
  activity: Activity;
  expanded: boolean;
  onExpandChange: (expanded: boolean) => void;
};

const ActivityCard: React.FC<ActivityCardProps> = ({
  activity,
  expanded,
  onExpandChange,
}) => {
  const { completed, note } = activity;
  const hasNotes = Boolean(note);

  return (
    <Card
      className="flex flex-col px-4 py-0"
      data-testid={`activity-card-${activity.id}`}
      flavor={completed ? 'regular' : undefined}
      zIndex={completed ? '0' : '2'}>
      {hasNotes ? (
        <AccordionRow
          expanded={expanded}
          hasBorder={false}
          isFullWidth
          setExpanded={onExpandChange}
          title={<ActivityHeader activity={activity} />}>
          <ActivityContent activity={activity} />
        </AccordionRow>
      ) : (
        <div className="py-3">
          <ActivityHeader activity={activity} />
        </div>
      )}
    </Card>
  );
};

export default ActivityCard;
